import "../../App.css";
import React, { Suspense, useEffect } from "react";
import Sidebar from "../../Module/sidebar";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Loading from "../../Component/Loading";
import {
  SalesUpsellingEmpPanelSidebarData,
  SalesUpsellingPanelSidebarData,
} from "../../Module/salesUpsellingPanelSidebarData";
import ScholarshipExamResult from "./scholarshipExamResult";
import Leads from "./leads";
import { useSelector } from "react-redux";
import CommonRoutes from "../Common/commonRoute";
import { useDispatch } from "react-redux";
import { Logout, setInitialState } from "../../Action/authAction";

const ExamResults = React.lazy(() => import("./examResults"));
const AssuredRevenueSales = React.lazy(() =>
  import("../Finance/assuredRevenueSales")
);
const MovementsOfMeeting = React.lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting")
);
const EditMovementsOfMeeting = React.lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting")
);

function SalesDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    role: state?.Auth?.userInfo?.role,
    authToken: state?.Auth?.authToken,
  }));

  useEffect(() => {
    if (!(role === "SALES" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, Navigate, authToken]);
  // useEffect(() => {
  //   setMinDate(moment.utc(new Date()).format("YYYY-MM-DD"));
  //   getData();
  // }, []);
  return (
    <div className="AppBox">
      <Sidebar
        data={
          loginType === 2
            ? SalesUpsellingEmpPanelSidebarData
            : SalesUpsellingPanelSidebarData
        }
      />
      <div className="dashboard">
        {
          <CommonRoutes loginType={loginType} defaultPage={<ExamResults />}>
            <Route path="/" element={<ExamResults />} />
            <Route path="examResults" element={<ExamResults />} />
            <Route
              path="ScholarshipExamResult"
              element={<ScholarshipExamResult />}
            />
            <Route path="leads" element={<Leads />} />
            <Route path="secondinstallment" element={<AssuredRevenueSales />} />
            <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
            <Route
              path="editMovementsOfMeeting"
              element={<EditMovementsOfMeeting />}
            />
          </CommonRoutes>
        }
      </div>
    </div>
  );
}

export default SalesDashboard;
